import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import OwLabel from "../../shared/OwLabel/OwLabel";
import "./LogOff.scss";
import UserService from "../../../services/UserService";
import { SocketContext } from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

export const LogOff = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const userModel = useContext(UserContext);
    const uiContext = useContext(UiContext);
    const location = useLocation();

    useEffect(() => {
        document.title = "Orderwerks >> Logging Off";

        uiContext.toggleSidebar(false);

        // Check if this logout was triggered by idle timeout
        const state = location.state as { fromIdleTimeout?: boolean; navTo?: string } | null;

        const logoutOptions: any = {
            socket,
            userModel,
        };

        // Only add navTo for idle timeout logouts
        if (state?.fromIdleTimeout && state?.navTo) {
            logoutOptions.navTo = state.navTo;
        }

        UserService.performLogout(logoutOptions);
    }, []);

    return (
        <div className={"LogOff"}>
            <div>
                <OwLabel title={"logging_off"} leftIconClass={"fas fa-circle-notch fa-spin"} />
            </div>
        </div>
    );
};
